import {
  DASHBOARD_FILES_COUNT,
  DASHBOARD_FILES_COUNT_SUCCESS,
  DASHBOARD_FILES_COUNT_ERROR,
} from "./actionTypes"

const initialState = {
  filesCount: {year: {data: [], categories: []}, month: {data: [], categories: []}},
  loadingFilesCount: false,
  errorFilesCount: "",
}

const Dashboard = (state = initialState, action) => {
  switch (action.type) {
    case DASHBOARD_FILES_COUNT:
      state = {
        ...state,
        filesCount: {year: {data: [], categories: []}, month: {data: [], categories: []}},
        loadingFilesCount: true,
        errorFilesCount: "",
      }
      break
    case DASHBOARD_FILES_COUNT_SUCCESS:
      state = {
        ...state,
        filesCount: action.payload.data.response,
        loadingFilesCount: false,
      }
      break
    case DASHBOARD_FILES_COUNT_ERROR:
      state = {
        ...state,
        loadingFilesCount: false,
        errorFilesCount: action.payload,
      }
      break
    default:
      state = {...state}
      break
  }
  return state
}

export default Dashboard
